import NameChangeModal from './NameChangeModal';

export default NameChangeModal;
